import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGift = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "2 2 20 20",
	strokeWidth: 1.5,
	fill: "none",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M5.75 11.25H18.25V17.25C18.25 18.3546 17.3546 19.25 16.25 19.25H7.75C6.64543 19.25 5.75 18.3546 5.75 17.25V11.25Z",
			stroke: "currentColor",
			strokeWidth: "inherit",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.75 7.75H19.25V11.25H4.75V7.75Z",
			stroke: "currentColor",
			strokeWidth: "inherit",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12 19V11.5",
			stroke: "currentColor",
			strokeWidth: "inherit",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.5 7.5L15.25 4.75",
			stroke: "currentColor",
			strokeWidth: "inherit",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.5 7.5L8.75 4.75",
			stroke: "currentColor",
			strokeWidth: "inherit",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgGift;
